import { Link } from "react-router-dom";
import { Heart, ShieldCheck, MessageSquare, Users, Flag, AlertTriangle } from "lucide-react";

const RULES = [
  { icon: Heart, title: "Respect wins the league", body: "Bring the same energy you'd want back. Rivalry is fine. Cruelty isn't. No slurs, no dehumanising language, ever." },
  { icon: ShieldCheck, title: "Be yourself", body: "Use recent photos of you. No pictures of celebrities, other people, or filters that hide your face. Verify your photo to earn the Supporter badge." },
  { icon: Users, title: "Adults only", body: "Footymatch is for people aged 18 and over. Any profile suggesting under-18 is banned and, where required, reported." },
  { icon: MessageSquare, title: "Consent is everything", body: "No unsolicited explicit messages or photos. If someone doesn't reply, move on — one polite follow-up is fine, three isn't." },
  { icon: Flag, title: "Report, don't retaliate", body: "See something dodgy — a fake, a harasser, someone underage? Hit the three-dots menu → Report. We look at every one." },
  { icon: AlertTriangle, title: "Zero tolerance", body: "Automatic ban for: hate speech, harassment, sexual content involving minors, threats of violence, spam, scams, or impersonation." },
];

export default function Guidelines() {
  return (
    <div className="min-h-screen bg-footy-bg text-white grain">
      <div className="max-w-3xl mx-auto px-5 py-14">
        <Link to="/" className="text-footy-red text-xs uppercase tracking-[0.25em] font-bold" data-testid="guidelines-back">← Back to Footymatch</Link>
        <h1 className="font-display text-5xl sm:text-6xl uppercase mt-4 leading-none tracking-tight">Community Guidelines</h1>
        <p className="text-slate-400 mt-3 text-sm">Footymatch is for finding love, friendship and matchday mates. Here's how we keep the terrace safe for everyone.</p>

        <div className="mt-10 grid sm:grid-cols-2 gap-5">
          {RULES.map(({ icon: Icon, title, body }) => (
            <div key={title} className="footy-card p-5">
              <div className="w-10 h-10 rounded-xl bg-footy-red/15 text-footy-red flex items-center justify-center mb-3"><Icon size={18} /></div>
              <h2 className="font-display text-xl uppercase tracking-wide">{title}</h2>
              <p className="text-sm text-slate-300 mt-2 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 footy-card p-6 border-footy-red/40">
          <h2 className="font-display text-2xl uppercase tracking-wide">If someone is in danger</h2>
          <p className="text-sm text-slate-300 mt-2 leading-relaxed">If you or someone else is in immediate danger, call 999. To report a crime that has happened, call 101 or use <a className="text-footy-red font-semibold" href="https://www.report-it.org.uk" target="_blank" rel="noreferrer">report-it.org.uk</a>. Support for anyone impacted by relationship abuse: <a className="text-footy-red font-semibold" href="https://www.refuge.org.uk" target="_blank" rel="noreferrer">refuge.org.uk</a>.</p>
        </div>
      </div>
    </div>
  );
}
